<script setup lang="ts">
</script>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
    name: 'ToolTipStandartDescription',

    props: {
        text: {
            type: String,
            required: false,
            default: '',
        },
    },
})
</script>

<template>
    <span>
        {{ text }}

        <slot/>
    </span>
</template>

<style scoped lang="scss">
span {
    display: flex;
    color: white;
    font-size: 13px;
    max-width: 400px;
}
</style>
